<template>
    <modal v-model="fade" class-name="vertical-center-modal" width="360" :mask-closable="maskClosable"
           @on-visible-change="changeModal">
        <div slot="header">
            <div class="login-header">{{title}}</div>
        </div>
        <div slot="close">
            <div class="close" @click="hide">x</div>
        </div>
        <Form class="form-group" ref="loginData" :model="loginData" :rules="ruleValidate">
            <FormItem prop="phone">
                <Input type="text" size="large" v-model.trim="loginData.phone" :placeholder="placeholderInfo.acct">
                    <Icon type="ios-contact" color="#2d8cf0" slot="prefix"/>
                </Input>
            </FormItem>
            <FormItem prop="pwd">
                <Input type="password" ref="passwordBtn" size="large" v-model.trim="loginData.pwd"
                       :placeholder="placeholderInfo.pwd">
                    <Icon type="ios-lock-outline" color="#2d8cf0" slot="prefix"/>
                </Input>
            </FormItem>
            <div class="forget-pwd"><a href="#" @click="toRouter('toResetPwd')">忘记密码？</a></div>
            <FormItem class="form-footer">
                <Button type="primary" long size="large" :loading="isLoading" @click="handleSubmit('loginData')">
                    <span v-if="!isLoading" style="font-size: 16px">登录</span>
                    <span v-else>Loading...</span>
                </Button>
            </FormItem>
            <div class="toRegister">还没有账号？<a href="#" @click="toRouter('toRegister')">立即注册</a></div>
        </Form>
        <div slot="footer"></div>
    </modal>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import api from '../../api/api'

    var self;
    export default {
        props: {
            title: {
                type: String,
                default: '登录'
            },
            placeholderInfo: {
                type: Object,
                default() {
                    return {
                        acct: '请输入用户号或者注册手机号',
                        pwd: '请输入密码'
                    };
                }
            },
            maskClosable: {
                type: Boolean,
                default: true
            }
        },
        data: () => {
            return {
                fade: false,
                isLoading: false,
                loginData: {
                    phone: '',
                    pwd: ''
                },
                ruleValidate: {
                    phone: [
                        {required: true, message: '账号不能为空', trigger: 'blur'},
                        {type: 'string', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '密码不能为空', trigger: 'blur'},
                        {type: 'string', trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {},
        mounted() {
            self = this;
            this.addEvent()
        },
        methods: {
            ...mapActions([
                'loginSuccess'
            ]),
            addEvent() {
                document.onkeydown = function (e) {
                    e = e || window.event;
                    if ((e.keyCode || e.which) == 13) {
                        // console.log(e)
                        self.handleSubmit('loginData')
                    }
                }
            },
            _initModalData() {
                this.loginData = {
                    phone: '',
                    pwd: ''
                }
            },
            handleSubmit(name) {
                var self = this;
                console.log('handleSubmit')
                this.isLoading = true;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var data = this.$refs[name].model
                        api.login(data).then(res => {
                            self.isLoading = false;
                            self.loginSuccess(res)
                            self.hide()
                        }).catch(error => {
                            self.isLoading = false;
                            self.$Message.error(error.info)
                        })
                    } else {
                        self.isLoading = false;
                        this.$Message.error('表单验证失败!')
                    }
                })
            },
            changeModal(data) {
                if (!data) {
                    this.hide()
                }
            },
            hide() {
                this._initModalData()
                this.fade = false
            },
            open() {
                this.fade = true;
            },
            toRouter(key) {
                this.$emit(key)
            }
        }
    }
</script>

<style scoped lang="scss">
    .login-header {
        font-size: 18px;
        text-align: left;
        letter-spacing: 3px;
        color: #333;
        font-weight: 600;
    }

    .close {
        width: 18px;
        height: 18px;
        color: #fff;
        font-size: 14px;
        margin-top: 5px;
        text-align: center;
        line-height: 18px;
        background: #ccc;
        border-radius: 15px
    }

    .form-group {
        width: 80%;
        margin: 0 auto;

        .form-item {
            padding-top: 20px;
        }
    }

    .ivu-input-prefix i {
        color: #2d8cf0;
    }

    .forget-pwd {
        text-align: right;
        padding-bottom: 10px;
        font-size: 14px;
    }

    .toRegister {
        text-align: left;
        /*padding: 10px 0;*/
    }
</style>
